// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ballEmptySlot[data-v-5a52e07b] {\n  border-width: 1px;\n  --tw-border-opacity: 1;\n  border-color: rgba(0, 0, 0, var(--tw-border-opacity));\n  --tw-bg-opacity: 1;\n  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));\n}\n.hovered[data-v-5a52e07b] {\n  opacity: 0.2;\n}\n.movingBall[data-v-5a52e07b] {\n  transition: all 1s ease-out;\n}\n", ""]);
// Exports
module.exports = exports;
